import { action, atom } from '@reatom/framework'
import BigNumber from 'bignumber.js'
import { t } from 'i18next'

import { Result } from '@blade/std-lib'
import { Error } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { LimitOrderModel } from '@root/entities/limit-order'
import type { PairAddress } from '@root/entities/pair'
import type { WalletId } from '@root/entities/wallet'

export const reatomEditLimitOrderDrawer = ({
  order,
}: {
  walletId: WalletId
  pairAddress: PairAddress
  order: LimitOrderModel
}) => {
  const editCostAtom = atom(BigNumber(0), 'editCostAtom')

  const updateOrderInternalAction = action(async (_ctx) => {
    return Result.fail(Error.UnknownError.fromUnknown('not implemented'))
  }, 'updateOrderInternalAction')

  const updateOrderStateAtom = reatomRequest({
    execAction: updateOrderInternalAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `${order.id}`,
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      showSnackbarAction(ctx, {
        text: t('order.edit-completed'),
        intent: 'success',
      })
    },
  })

  return {
    editCostAtom,
    updateOrderStateAtom,
  }
}
